<template>
  <div
    role="checkbox"
    :class="[baseCss, disabled ? ['disabled', 'pointer-events-none'] : null]"
    :title="label">
    <label
      :class="['whitespace-nowrap', 'inline-block', 'align-middle']">
      <input
        @change="$emit('input', !checked)"
        type="checkbox"
        tabindex="-1"
        :id="id"
        :aria-checked="checked"
        :name="name"
        :checked="checked"
        :disabled="disabled"
        :class="['absolute', 'clip-0']" /><!--
        --><span
      :class="[internalBgColor, 'transition-all', 'duration-200', 'ease-in-out', 'inline-block', 'align-middle']"><!--
      --><span
      :class="['transition-all', 'duration-200', 'ease-in-out', 'bg-white', 'inline-block', 'align-middle']" />
      </span><!--
      --><span
      v-if="label"
      v-html="label"
      :class="[`text-${labelSize}`, 'inline-block', 'align-middle', internalLabelColor, 'px-2']" />
    </label>
  </div>
</template>
<script>
import methods from '../../mixins/methods'
import computed from '../../mixins/computed'
import props from '../../mixins/props'

export default {
  name: 'Switcher',
  mixins: [
    props,
    methods,
    computed
  ],
  model: {
    prop: 'checked',
    event: 'input'
  },
  data () {
    return {
      baseCss: this.componentBaseCss('switcher', ['p-1', 'inline-block', 'align-middle', 'select-none', 'cursor-pointer'])
    }
  },
  props: {
    value: null,
    checked: null,
    labelColor: {
      type: String,
      default: 'black'
    },
    labelSize: {
      type: String,
      default: 'sm',
      validator: value => {
        return ['xs', 'sm', 'base', 'lg', 'xl'].includes(value)
      }
    },
    label: {
      type: String
    },
    bgColor: {
      type: String,
      default: 'black'
    },
    disabled: {
      type: Boolean
    },
    id: {
      type: String
    },
    name: {
      type: [String, Number]
    }
  },
  methods: {
    change () {
      const value = this.value
      if (this.checked.includes(value)) {
        this.checked.splice(this.checked.indexOf(value), 1)
      } else {
        this.checked.push(value)
      }
    }
  }
}
</script>
<style>
.bcq-switcher input + span
{
  height: 1.25em;
  border-radius: 1.25em;
  width: 2.5em;
  position: relative;
  padding: 1px;
  border: solid 2px transparent;
}

.bcq-switcher input:not(:checked) + span
{
  background: #666 !important;
  opacity: .75;
}

.bcq-switcher input + span span
{
  content: "";
  display: block;
  height: calc(1.25em + -6px);
  width: calc(1.25em + -6px);
  border-radius: 100%;
  position: absolute;
  left: 1px;
}

.bcq-switcher input:checked + span span
{
  left: calc(1.25em + 1px);
}

.bcq-switcher *
{
  cursor: inherit;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/bcq-ui/components/switcher/switcher.vue